import { TextIcon } from "../../../CommonUI/TextIcon";
import React from "react";
import { BaseJSONXMLElementEditor } from "./BaseJSONXMLElementEditor";
import { JSONXMLStringElement } from "../../../rule-engine-core/TextMerge/Elements/JSONXML/JSONXMLStringElement";

export class JSONXMLStringEditor extends BaseJSONXMLElementEditor<JSONXMLStringElement> {
    getIcon(): JSX.Element {
        return <TextIcon name={"abc"} />;
    }
}
